/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Retry_SuccessInputs */

const vi_print_admin_retry_success = /** @type {(inputs: Print_Admin_Retry_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đưa lệnh in lại vào hàng đợi`)
};

/**

* @param {Print_Admin_Retry_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_retry_success = /** @type {((inputs?: Print_Admin_Retry_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Retry_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_retry_success(inputs)
});